(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oc-blog-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeCarousel = (root) => {
      if (!root || root.dataset.ocBlogCarouselReady === 'true') return;

      const track = root.querySelector('[data-oc-blog-track]');
      const controls = root.querySelector('[data-oc-blog-controls]');
      const previousButton = root.querySelector('[data-oc-blog-prev]');
      const nextButton = root.querySelector('[data-oc-blog-next]');

      if (!track || !controls || !previousButton || !nextButton) return;

      root.dataset.ocBlogCarouselReady = 'true';

      const getStep = () => {
        const firstCard = track.firstElementChild;
        if (!firstCard) return track.clientWidth;

        const styles = window.getComputedStyle(track);
        const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;

        return firstCard.getBoundingClientRect().width + gap;
      };

      const updateControls = () => {
        const canUseArrows = window.matchMedia(
          '(max-width: 1199px) and (hover: hover) and (pointer: fine)'
        ).matches;
        const maximumScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        const hasOverflow = maximumScroll > 2;

        controls.hidden = !(canUseArrows && hasOverflow);

        if (!canUseArrows || !hasOverflow) {
          previousButton.disabled = true;
          nextButton.disabled = true;
          return;
        }

        previousButton.disabled = track.scrollLeft <= 2;
        nextButton.disabled = track.scrollLeft >= maximumScroll - 2;
      };

      previousButton.addEventListener('click', () => {
        track.scrollBy({ left: -getStep(), behavior: 'smooth' });
      });

      nextButton.addEventListener('click', () => {
        track.scrollBy({ left: getStep(), behavior: 'smooth' });
      });

      track.addEventListener('scroll', () => {
        window.requestAnimationFrame(updateControls);
      }, { passive: true });

      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(updateControls);
        observer.observe(track);
      } else {
        window.addEventListener('resize', updateControls, { passive: true });
      }

      updateControls();
    };

    const initializeAll = (container = document) => {
      container.querySelectorAll('[data-oc-blog-section]').forEach(initializeCarousel);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll());
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oc-guarantees"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeGuarantees = (root) => {
      if (!root || root.dataset.ocGuaranteesReady === 'true') return;

      const track = root.querySelector('[data-oc-guarantees-track]');
      const controls = root.querySelector('[data-oc-guarantees-controls]');
      const previousButton = root.querySelector('[data-oc-guarantees-prev]');
      const nextButton = root.querySelector('[data-oc-guarantees-next]');

      if (!track || !controls || !previousButton || !nextButton) return;

      root.dataset.ocGuaranteesReady = 'true';

      const getStep = () => {
        const firstItem = track.firstElementChild;
        if (!firstItem) return track.clientWidth;

        const styles = window.getComputedStyle(track);
        const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;

        return firstItem.getBoundingClientRect().width + gap;
      };

      const updateControls = () => {
        const canUseArrows = window.matchMedia(
          '(max-width: 989px) and (hover: hover) and (pointer: fine)'
        ).matches;
        const maximumScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        const hasOverflow = maximumScroll > 2;

        controls.hidden = !(canUseArrows && hasOverflow);

        if (!canUseArrows || !hasOverflow) {
          previousButton.disabled = true;
          nextButton.disabled = true;
          return;
        }

        previousButton.disabled = track.scrollLeft <= 2;
        nextButton.disabled = track.scrollLeft >= maximumScroll - 2;
      };

      previousButton.addEventListener('click', () => {
        track.scrollBy({ left: -getStep(), behavior: 'smooth' });
      });

      nextButton.addEventListener('click', () => {
        track.scrollBy({ left: getStep(), behavior: 'smooth' });
      });

      track.addEventListener(
        'scroll',
        () => window.requestAnimationFrame(updateControls),
        { passive: true }
      );

      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(updateControls);
        observer.observe(track);
      } else {
        window.addEventListener('resize', updateControls, { passive: true });
      }

      updateControls();
    };

    const initializeAll = (container = document) => {
      container.querySelectorAll('[data-oc-guarantees]').forEach(initializeGuarantees);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll());
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
